export default __webpack_public_path__ + "static/media/08_MANIC.c4f07872.png";